import { render, staticRenderFns } from "./MissionLeftIcon.vue?vue&type=template&id=c84a98fc"
import script from "./MissionLeftIcon.vue?vue&type=script&lang=ts"
export * from "./MissionLeftIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports